import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable, of, Subscriber, Subscription } from 'rxjs';
import { ServiceViewComponent } from 'src/app/modules/appointment-wizard/components/service-view/service-view.component';
import { AppRolesModel, GenericKeysModel } from 'src/app/shared/models';
import { PackWizard } from 'src/app/shared/state/pack-wizard/pack-wizard.model';
import { PackWizardQuery } from 'src/app/shared/state/pack-wizard/pack-wizard.query';
import { SettingsQuery } from 'src/app/shared/state/settings/settings.query';

@Component({
  selector: 'app-pack-item',
  templateUrl: './pack-item.component.html',
  styleUrls: ['./pack-item.component.scss']
})
export class PackItemComponent {
  @Input() pack: PackWizard;
  @Input() packIsChecked$: Observable<boolean>;
  @Output() packToggleEvent = new EventEmitter<any>();

  public checked: boolean;

  private subscription$: Subscription;

  constructor(
    private packWizardQuery: PackWizardQuery,
    private settingsQuery: SettingsQuery,
    private modalController: ModalController,
  ) { }

  ngOnInit() {
    this.subscription$ = this.packWizardQuery.selectEntity(
      e => e.id === this.pack.id
    ).subscribe(({ isChecked }) => {
      this.checked = isChecked;
    });

  }

  onPackToggle() {
    this.packToggleEvent.emit(this.pack);
  }

  get showModalService() {
    if (
      this.settingsQuery.appRole === AppRolesModel.Personalized ||
      this.settingsQuery.appRole === AppRolesModel.PersonalizedBrowser ||
      ((this.settingsQuery.appRole === AppRolesModel.Generic ||
        this.settingsQuery.appRole === AppRolesModel.GenericBrowser) &&
        this.settingsQuery.genericKey === GenericKeysModel.LPG)
    ) {
      return true;
    }
    return false;
  }

  openServiceInfoModal($event: MouseEvent) {
    if (this.showModalService) {
      $event.preventDefault();
      $event.cancelBubble = true;

      this.modalController.create({
        component: ServiceViewComponent,
        cssClass: this.settingsQuery.browser ? 'modal-flowwwer modal-browser' : 'modal-flowwwer',
        componentProps: {
          serviceId: this.pack.packId,
        },
      }).then(modal => modal.present());
    }
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
